var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc2c38;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail.ru"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mail.ru-2",
    "data-name": "Mail.ru",
    className: "cls-2",
    d: "M719.58,384.58c0,19.76-9.25,29-20.87,29a18.86,18.86,0,0,1-16-8.83A28.83,28.83,0,1,1,691,384.58V394c0,4.77,3.36,8.13,7.71,8.13,5.18,0,9.38-4.35,9.38-17.52a46.2,46.2,0,1,0-21.29,38.67l7.56,8.69A56.92,56.92,0,0,1,662,441.89a57.45,57.45,0,1,1,57.58-57.31ZM662.14,402.1a17.52,17.52,0,1,0-17.52-17.52A17.52,17.52,0,0,0,662.14,402.1Z",
    transform: "translate(-554 -277)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailru);
export default __webpack_public_path__ + "static/media/Mail.ru.37f18c0b0ca22e40b906758e217f0d5d.svg";
export { ForwardRef as ReactComponent };